import { builderManager } from "appworks/server/builders/builder-manager";
import { commsManager } from "appworks/server/comms-manager";
import { gamevyPartnerConnectConfigRecordBuilder } from "gamevy/integration/builders/records/gamevy-partner-connect-config-record-builder";
import { lineResultsBuilder } from "gamevy/integration/builders/results/line-result-builder";
import { tgrHybridSpinRecordBuilder } from "integration/builders/records/partner-connect/tgr-hybrid-spin-record-builder";
import { tgrPartnerConnectConfigRecordBuilder } from "integration/builders/records/partner-connect/tgr-partner-connect-config-record-builder";
import { tgrRecoveryHybridSpinRecordBuilder } from "integration/builders/records/partner-connect/tgr-recovery-spin-record-builder";
import { tgrRestoreRecordBuilder } from "integration/builders/records/partner-connect/tgr-restore-record-builder";
import { partnerConnectScatterResultBuilder } from "integration/builders/results/partner-connect/partner-connect-scatter-result-builder";
import { partnerConnectWaysResultsBuilder } from "integration/builders/results/partner-connect/partner-connect-ways-result-builder";
import { tgrFreeSpinWinResultBuilder } from "integration/builders/results/tgr-freespin-win-result-builder";
import { tgrInstantWinResultBuilder } from "integration/builders/results/tgr-instant-win-result-builder";
import { partnerConnectSpinRequestBuilder } from "partner-connect/integration/builders/requests/partner-connect-spin-request-builder";
import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";

export function TGRSetupIntegration() {
    commsManager.connector = partnerConnectConnector;

    builderManager.addRequestBuilder(partnerConnectSpinRequestBuilder);

    builderManager.addRecordBuilder(tgrPartnerConnectConfigRecordBuilder);
    builderManager.addRecordBuilder(gamevyPartnerConnectConfigRecordBuilder);
    builderManager.addRecordBuilder(tgrRestoreRecordBuilder);
    builderManager.addRecordBuilder(tgrRecoveryHybridSpinRecordBuilder);
    builderManager.addRecordBuilder(tgrHybridSpinRecordBuilder);
    builderManager.addResultBuilder(partnerConnectWaysResultsBuilder);
    builderManager.addResultBuilder(partnerConnectScatterResultBuilder);

    builderManager.addResultBuilder(lineResultsBuilder);
    builderManager.addResultBuilder(tgrFreeSpinWinResultBuilder);
    builderManager.addResultBuilder(tgrInstantWinResultBuilder);
}
